import React from "react";
import {
  workflowStepFailedAlertContainerCN,
  alertErrorCN,
  alertErrorIconBlockCN,
  alertErrorTextBlockCN,
  alertErrorTextBlockHeaderCN,
  alertErrorTextBlockMessageCN,
} from "./WorkflowStepContainer/styles";
import { classes } from "typestyle";

type AlertErrorProps = {
  header: string | JSX.Element;
  message: string;
};

export default function AlertError(props: AlertErrorProps) {
  return (
    <div className={classes(alertErrorCN, workflowStepFailedAlertContainerCN)}>
      <div className={alertErrorIconBlockCN}>
        <img src="./ic-warning-red.svg" />
      </div>
      <div className={alertErrorTextBlockCN}>
        <div className={alertErrorTextBlockHeaderCN}>{props.header}</div>
        <div className={alertErrorTextBlockMessageCN}>{props.message}</div>
      </div>
    </div>
  );
}
